import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../../Auth";
import { Button, Card, Col, Container, FormGroup, FormLabel, Row } from "react-bootstrap";
import { ChevronLeft, PlusLg, Save } from "react-bootstrap-icons";
import { fetchApi, getDefaultData, getStructure } from "../../../Funciones";
import { Campo, Formulario, TipoCampo } from "../../Formulario";
import { Acordeon } from '../../Acordeon';
import { ModuleData, ModuleField, ModulePanel, ModuleSelector } from "../../ModuleLib";


export const Edit: React.FC<{ id?: any }> = ({ id }) => {

	const params = useParams()
	let nav = useNavigate();
	let auth = useAuth()

	const [PID, setPID] = useState("")
	const [data, setData] = useState(new FormData());

	const [estructura, setEstructura] = useState<ModuleData[]>([])
	const [navegacion, setNavegacion] = useState<any[]>([])
	const [instanceNumber, setInstanceNumber] = useState(1)

	const getData = async (pid: any) => {
		var resp = await fetchApi(auth.user.token, "page", {
			cmd: "get",
			nav: 1,
			id: pid
		})
		if (resp.estado === "ok") {
			var d = new FormData();
			["title", "description"].forEach(campo => {
				d.set(campo, resp[campo])
			});
			var es = JSON.parse(resp["structure"].replaceAll("\n", "\\n").replaceAll("\r", "\\r").replaceAll("\t", "\\t"))

			setEstructura(await getStructure(es))
			setInstanceNumber(es.length + 1)
			setData(d)
		}
		if (resp.nav) {
			setNavegacion(resp.nav)
		}
	}

	useEffect(() => {
		if (auth.user) {
			var pid = ""
			var d = new FormData();

			if (id && id !== "") {
				pid = id
			}
			else {
				if (params.id && params.id !== "") {
					pid = params.id
				}
			}

			if (pid !== "") {
				getData(pid)
			}
			else {
				setData(d)
			}
			setPID(pid)
		}
		// eslint-disable-next-line
	}, [auth.user, params.id, id])

	const submit = async (ev: any) => {

		var es: any = []
		estructura.forEach(data => {
			data.Module!.getFields().forEach((field: ModuleField) => {
				if (field.mapSaveData) {
					data.Data!.set(field.name, field.mapSaveData(data.Data!.get(field.name)))
				}
			})
			es.push({
				module: data.Module!.getModuleName(),
				data: Object.fromEntries(data.Data!)
			})
		})

		data.set("cmd", "save")
		data.set("isTemplate", "1")
		data.set("pid", PID)
		data.set("structure", JSON.stringify(es))
		let res = await fetchApi(auth.user.token, "page", data)
		if (res.estado === "ok") {
			nav(-1)
		}
		else {
			alert(res.msg)
		}
	}

	const change = (ev: any) => {
		//validaciones
		let d = new FormData()
		data.forEach((val, key) => {
			d.set(key, val)
		})
		if (ev.target.targetElm) { //editor
			d.set(ev.target.targetElm.name, ev.target.getContent())
		}
		else if (ev.target.type !== "file") {
			d.set(ev.target.name, ev.target.value)
		}
		else {
			if (ev.target.files.length > 0)
				d.set(ev.target.name, ev.target.files[0])
			else
				d.delete(ev.target.name)
		}
		setData(d)
	}

	const agregarModulo = async (modulo: any) => {
		var nueva = estructura
		//nueva.push({ Module: modulo, Data: new Map<string, any>(), Instance: instanceNumber })
		nueva.push({ Module: modulo, Data: await getDefaultData(modulo), Instance: instanceNumber })
		setEstructura(nueva)
		setInstanceNumber(instanceNumber + 1)
	}
	const eliminarModulo = (data: ModuleData) => {
		setEstructura(estructura.filter((value) => value.Instance !== data.Instance))
	}
	const colapsarModulo = (data: ModuleData) => {
		setEstructura(estructura.map(item => {
			if (data.Instance === item.Instance) {
				item.Collapsed = !item.Collapsed
				return item
			}
			else {
				return item;
			}
		}))
	}
	const actualizarModulo = (data: ModuleData, field: ModuleField, value: any) => {
		setEstructura(estructura.map(item => {
			if (data.Instance === item.Instance) {
				item.Data!.set(field.name, value)
				return item
			}
			else {
				return item;
			}
		}))
	}

	return <>
		<Button size="sm" variant="dark" onClick={() => { nav(-1) }} className="my-2"><ChevronLeft /> Volver</Button>
		<Formulario submit={(ev: any) => submit(ev)} change={(ev: any) => change(ev)} datos={data}>

			<h4>{PID !== "" ? "Editar" : "Nueva"} Plantilla <Button type="submit" variant="primary"><Save /> Guardar</Button></h4>
			<Row>
				<Col xs={5}>
					<Card className="shadow">
						<Acordeon
							header={<Card.Header className="bg-dark text-white">Información</Card.Header>}
							body={<Card.Body>
								<FormGroup className="form-floating">
									<Campo tipo={TipoCampo.Texto} nombre="title" required />
									<FormLabel className="text-primary" htmlFor="title">Título</FormLabel>
								</FormGroup>
								<FormGroup className="form-floating mt-3">
									<Campo tipo={TipoCampo.AreaTexto} rows={3} nombre="description" />
									<FormLabel className="text-primary" htmlFor="description">Descripción</FormLabel>
								</FormGroup>
							</Card.Body>} />
					</Card>
					<Card className="shadow mt-2">
						<Acordeon
							header={<Card.Header className="bg-dark text-white">Estructura</Card.Header>}
							body={<Card.Body className="p-0">
								{estructura.map((data: ModuleData, i: number) => {
									return <ModulePanel
										key={data.Instance + "_" + i}
										data={data}
										index={i}
										onDrop={(ev: any) => {
											var from = parseInt(ev.dataTransfer.getData("item"))
											var to = i;
											var nueva = [...estructura]
											var item = nueva.splice(from, 1)[0]
											nueva.splice(to, 0, item)
											setEstructura(nueva)
										}}
										collapse={colapsarModulo}
										remove={eliminarModulo}
										update={actualizarModulo}
										nav={navegacion} fullNav={navegacion} />
								})}

								<div className="p-2 text-end">
									<ModuleSelector template onSelect={(module: any) => { agregarModulo(module) }}><Button size="sm" variant="secondary"><PlusLg /></Button></ModuleSelector>
								</div>
							</Card.Body>} />
					</Card>

				</Col>
				<Col xs={7}>
					<Card className="shadow">
						<Card.Header className="bg-dark text-white">Preview</Card.Header>
						<Card.Body style={{ zoom: .7 }}>
							<Container>
								{estructura.map((data: ModuleData) => {
									return <React.Fragment key={data.Instance}>
										{data.Module && <data.Module.Component data={data.Data!} nav={navegacion} />}
									</React.Fragment>
								})}
							</Container>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</Formulario>
	</>
}